import { render, staticRenderFns } from "./HeadingWithLine.vue?vue&type=template&id=34bc5390&scoped=true&"
import script from "./HeadingWithLine.vue?vue&type=script&lang=js&"
export * from "./HeadingWithLine.vue?vue&type=script&lang=js&"
import style0 from "./HeadingWithLine.vue?vue&type=style&index=0&id=34bc5390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bc5390",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34bc5390')) {
      api.createRecord('34bc5390', component.options)
    } else {
      api.reload('34bc5390', component.options)
    }
    module.hot.accept("./HeadingWithLine.vue?vue&type=template&id=34bc5390&scoped=true&", function () {
      api.rerender('34bc5390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/HeadingWithLine.vue"
export default component.exports